import React, { Component } from "react";
import ReCaptcha from "../common/recaptcha.component";
import { validateForgotPassword, forgotPassword } from "../../services/rest";
import {
  OTP_VALIDATION_ERROR,
  RETRY_CAPTCHA_MESSAGE
} from "../../utils/constants";
import Validator from "../../utils/Validator";
import ErrorHandler from "../../utils/error-handler";
import ToolTip from "../Login/ToolTip";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TaggingHelper from "../../tagging/tagging-helper";
import OtpInput from "../common/OtpInput/OtpInput";

toast.configure();
class ForgotPasswordForm extends Component {
  defaultState = {
    token: null,
    showRecaptcha: false,
    otp: "",
    inValidOtp: true,
    message: "",
    previousPropData: null
  };

  constructor(props) {
    super(props);
    if (props.data && props.data.previousState) {
      this.state = {
        ...props.data.previousState
      };
    } else {
      this.state = {
        ...this.defaultState,
        token: props.data.currentState.token,
        previousPropData: props.data.currentState,
        message: props.data.message,
        showRecaptcha: false
      };
    }
  }

  componentDidMount() {
    TaggingHelper.forgotPasswordOTPLandingEvent();
    if (this.props.data && this.props.data.text === "GET NEW OTP") {
      this.resendOTP();
    }
  }

  _onOtpChange = (otpValue) => {
    this.setState({
      inValidOtp: this.isInValidOTP(otpValue),
      otp: otpValue
    });
  };

  _onOtpComplete = (otpValue) => {
    this.setState({
      inValidOtp: this.isInValidOTP(otpValue),
      otp: otpValue
    });
  };

  _onVerifyCallback = (token) => {
    this.setState({ token, showRecaptcha: false });
    this.resendOTP();
  };

  isInValidOTP = (otp) => {
    return !Validator.isValidOtp(otp);
  };

  _onExpiredCallback = () => {
    this.setState({ token: null, showRecaptcha: true });
  };

  displayCaptcha = () => {
    this.setState({ token: null, showRecaptcha: true });
  };

  _onOtpLogin = (e) => {
    e.preventDefault();
    this.props.showUILoader(true);
    validateForgotPassword(this.state.previousPropData.username, this.state.otp)
      .then((response) => {
        if (response.data && response.data.result) {
          this.props.goto("CHANGE_PASSWORD", { currentState: this.state });
        } else {
          throw new Error("UNEXPECTED_ERROR");
        }
      })
      .catch((error) => {
        ErrorHandler.handleValidateForgotPasswordApiError(
          error,
          this.props.goto,
          this.state,
          "FORGOT_PASSWORD_OTP",
          this.state.previousPropData
        );
        const errorMessage = ErrorHandler.getErrorMessage(error).errorMessage;
        TaggingHelper.forgotPasswordErrorEvent(errorMessage);
      })
      .finally(() => {
        this.props.showUILoader(false);
      });
  };

  notify = (message) => {
    toast.dismiss();
    toast.success(message, { position: toast.POSITION.BOTTOM_LEFT });
  };

  resendOTP = () => {
    this.props.showUILoader(true);
    forgotPassword(this.state.previousPropData.username, this.state.token)
      .then((response) => {
        if (response.data && response.data.result && response.status === 200) {
          const message = response.data.result.message || "";
          this.notify(message);
        } else {
          throw new Error("UNEXPECTED_ERROR");
        }
      })
      .catch((error) => {
        const furtherActionFlag = ErrorHandler.handleResendOtpError(
          error,
          this.notify,
          this.displayCaptcha
        );
        if (furtherActionFlag) {
          ErrorHandler.handleForgotPasswordOtpRequestApiError(
            error,
            this.props.goto,
            this.state.previousPropData,
            "FORGOT_PASSWORD"
          );
        }
        const errorMessage = ErrorHandler.getErrorMessage(error).errorMessage;
        TaggingHelper.forgotPasswordErrorEvent(errorMessage);
      })
      .finally(() => this.props.showUILoader(false));
  };

  onGoBack = () => {
    this.props.goto("FORGOT_PASSWORD", {
      previousState: this.state.previousPropData
    });
  };

  formatMessageWithBoldMsisdn = (message) => {
    const msisdnPattern = /(\d{2,3}\*+\d{2,3})/;
    const match = message.match(msisdnPattern);
    
    if (match) {
      const parts = message.split(match[0]);
      return (
        <>
          {parts[0]}<strong>{match[0]}</strong>{parts[1]}
        </>
      );
    }
    return message;
  };

  render() {
    const { showRecaptcha, message, otp, inValidOtp } = this.state;
    return (
      <React.Fragment>
        <div className="card-header">
          <h2>Enter your OTP</h2>
          <p>{this.formatMessageWithBoldMsisdn(message)}</p>
        </div>
        <div className="field-group otp-field-group">
          <OtpInput
            length={6}
            onChange={this._onOtpChange}
            onComplete={this._onOtpComplete}
            hasError={otp.length === 6 && inValidOtp}
            autoFocus={true}
            isMasked={true}
            maskDelay={0}
          />
          {otp.length === 6 && inValidOtp && (
            <p className="infield-error-label">{OTP_VALIDATION_ERROR}</p>
          )}
        </div>
        <div className="action-button-wrapper">
          <button
            type="submit"
            className="btn btnRed"
            disabled={inValidOtp}
            onClick={(e) => this._onOtpLogin(e)}
            automationid="LOGIN_FORM_FORGOTPASSWORDFORM_2"
          >
            NEXT
          </button>
        </div>
        <div className="action-button-wrapper">
          <button
            type="button"
            className="btn btnWhite"
            onClick={this.onGoBack}
            automationid="LOGIN_FORM_FORGOTPASSWORDFORM_3"
          >
            BACK
          </button>
        </div>
        {showRecaptcha && (
          <div className="captcha-wrapper">
            <ReCaptcha
              sitekey={"6LdNAAwUAAAAALEhZyYgkqFtXUPKVhD5Fj2XaWUm"}
              verifyCallback={this._onVerifyCallback}
              expiredCallback={this._onExpiredCallback}
            />
          </div>
        )}
        <div className="card-footer">
          <p>
            {"Haven't received anything? "}
            <button
              type="button"
              className={`button-link ${
                showRecaptcha ? "button-link-disabled" : ""
              }`}
              automationid="LOGIN_FORM_FORGOTPASSWORDFORM_4"
              onClick={this.resendOTP}
            >
              {`  Resend OTP `}
            </button>
            {showRecaptcha && (
              <ToolTip
                tooltip_message={RETRY_CAPTCHA_MESSAGE}
                position={`top`}
              />
            )}
          </p>
        </div>
      </React.Fragment>
    );
  }
}

export default ForgotPasswordForm;
